module.exports = __webpack_public_path__ + "static/media/user-avatar.84db83bc.png";